import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CompetenciesService } from "../../competencies/competencies.service";
import { TrainingsTrackerGridComponent } from "./trainings_tracker_grid/trainings_tracker_grid.component";
import { CompetencyData } from "src/app/Models/competencyModel.model";

@Component({
  selector: 'trainingsTracker',
  templateUrl: './trainings_tracker_header.component.html',
  styleUrls: ['./trainings_tracker_header.component.css']
})

export class TrainingsTrackerHeaderComponent implements OnInit {
  data: any;
  public competencyData: CompetencyData = new CompetencyData();
  id: any;
  searchText = '';
  @ViewChild(TrainingsTrackerGridComponent) child: TrainingsTrackerGridComponent;

  callMyChild() {
    this.child.getToolsFunctionSearch();
  }

  constructor(private _service: CompetenciesService, private route: ActivatedRoute,

    private router: Router) { }
  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.id = Number(params.get('id'));
    });
  }

  createFunction() {
    this.router.navigate(['Home/addTrainings'])
    
  }

}
